import React, { Component } from "react";
import EmailComponent from "./emailComponent";
import { emailValidation } from "../../../../lib/utils/regex_cheat_sheet";
import Verification from "./verification";
class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: "",
      currentStep: "email",
      timer: 90000,
      otp: [],
    };
  }

  componentDidMount() {
    this.startTimer();
    if (this.props.onStepChange) {
      this.props.onStepChange(this.state.currentStep); // notify parent of "email"
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.timer !== this.state.mobileTime &&
      this.state.mobileTime > 0
    ) {
      clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.timer <= 1000) {
            clearInterval(this.timerInterval);
            return { timer: 0 };
          }
          return { timer: prevState.timer - 1000 };
        });
      }, 1000);
    }
    if (prevState.currentStep !== this.state.currentStep) {
      if (this.props.onStepChange) {
        this.props.onStepChange(this.state.currentStep);
      }
    }
  }

  startTimer = () => {
    this.timerInterval = setInterval(() => {
      if (this.state.timer <= 0) {
        clearInterval(this.timerInterval);
        this.setState({ otpExpired: true });
      } else {
        this.setState((prevState) => ({ timer: prevState.timer - 1000 }));
      }
    }, 1000);
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleSendOTP = () => {
    if (!emailValidation.test(this.state.email)) {
      this.setState({ emailError: "Please enter a valid email address." });
      return;
    }
    this.setState({ emailError: "" });
    this.setState({ currentStep: "verification" });
    console.log(`Sending OTP to ${this.state.email}`);
  };

  handleInputChange = (index, value) => {
    if (Array.isArray(value)) {
      this.setState({ otp: value });
    } else {
      const updatedOtp = [...this.state.otp];
      updatedOtp[index] = value;
      this.setState({ otp: updatedOtp});
    }
  };

  handleChangeStep = (step) => {
    this.setState({ currentStep: step }, () => {
      if (this.props.onStepChange) {
        this.props.onStepChange(step);
      }
    });
  };

  onOtpSend = () => {
    const otpValue = this.state.otp.map((digit) => digit).join("");
    console.log("OTP entered:", otpValue);
    this.setState({ currentStep: "otpStatus" });
  };

  formatTimer = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  setTimer = (time) => {
    this.setState({ timer: time });
  };

  OtpStatus = () => {
    let styles = this.props.styles;
    return (
      <div className={`${styles.email_otp} ${styles.email_otp__failed}`}>
        <div className={styles.email_otp__hero}>
          <div className={styles.email_otp__hero_icon}>
            <img src="images/mail_not_sent.svg" alt="Mail Not Sent" />
          </div>
          <p className={styles.email_otp__title}>Could not send OTP</p>
          <p className={styles.email_otp__subtitle}>Please try again later.</p>
          <button
            className={`${styles.email_otp__submit_btn} ${styles.email__failed__otp_btn}`}
            onClick={() => this.handleChangeStep("verification")}
          >
            Retry
          </button>
        </div>
      </div>
    );
  };

  handleBack = () => {
    const { currentStep } = this.state;
    if (currentStep === "verification") {
      this.handleChangeStep("email");
    } else if (currentStep === "profileComplete") {
      this.handleChangeStep("verification");
    } else if (currentStep === "changeEmail") {
      this.handleChangeStep("verification");
    } else {
      this.handleChangeStep("email");
    }
  };

  changeEmail = () => {
    let styles = this.props.styles;
    let isMobile = this.props.isMobile;
    console.log("bbbb", isMobile)
    return (
      isMobile ? (
        <div className={`${styles.email_otp} ${styles.email_otp__email_change}`}>
          {/* <div className={styles.email_otp__header}>
          <button
            type="button"
            className={styles.email_otp__close_btn}
            onClick={() => this.handleChangeStep("email")}
          >
            <img
              src="/back-arrow.png"
              alt="Back"
              className={styles.email_otp__close_icon}
            />
          </button>
        </div> */}

          <div className={`${styles.email_otp__content}`}>
            <div className={styles.email_otp__hero}>
              <div className={styles.email_otp__hero_icon}>
                <img src="images/mail.svg" alt="mail" />
              </div>
              <p className={styles.email_otp__title}>Change Email</p>
              <p className={styles.email_otp__subtitle}>
                Changing Email will cancel the current OTP process
              </p>
            </div>

            <div className={`${styles.email_otp__submit_container} ${styles.email_otp__email_change_btn}`}>
              <button
                className={`${styles.email_otp__cancel_btn} `}
                onClick={() => this.handleChangeStep("verification")}
              >
                Cancel
              </button>
              <button
                className={styles.email_otp__submit_btn}
                onClick={() => this.handleChangeStep("email")}
              >
                Confirm & Change
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.email_otp} ${styles.email_otp__email_change}`}>
          {/* <div className={styles.email_otp__header}>
          <button
            type="button"
            className={styles.email_otp__close_btn}
            onClick={() => this.handleChangeStep("email")}
          >
            <img
              src="/back-arrow.png"
              alt="Back"
              className={styles.email_otp__close_icon}
            />
          </button>
        </div> */}

          <div className={`${styles.email_otp__content}`}>
            <div className={styles.email_otp__hero}>
              <div className={styles.email_otp__hero_icon}>
                <img src="images/mail.svg" alt="mail" />
              </div>
              <p className={styles.email_otp__title}>Change Email</p>
              <p className={styles.email_otp__subtitle}>
                Changing Email will cancel the current OTP process
              </p>
            </div>

            <div className={`${styles.email_otp__submit_container} ${styles.email_otp__email_change_btn}`}>
              <button
                className={`${styles.email_otp__cancel_btn} `}
                onClick={() => this.handleChangeStep("verification")}
              >
                Cancel
              </button>
              <button
                className={styles.email_otp__submit_btn}
                onClick={() => this.handleChangeStep("email")}
              >
                Confirm & Change
              </button>
            </div>
          </div>
        </div>
      )

    );
  };

  renderSteps() {
    const { currentStep, timer } = this.state;
    let styles = this.props.styles;
    switch (currentStep) {
      case "email":
        return (
          <EmailComponent
            handleEmailChange={this.handleEmailChange}
            handleSendOTP={this.handleSendOTP}
            email={this.state.email}
            emailError={this.state.emailError}
            styles={styles}
          />
        );
      case "verification":
        return (
          <Verification
            email={this.state.email}
            timer={this.formatTimer(timer)}
            handleInputChange={this.handleInputChange}
            handleChangeStep={this.handleChangeStep}
            otp={this.state.otp}
            onOtpSend={this.onOtpSend}
            setTimer={this.setTimer}
            styles={styles}
          />
        );
      case "otpStatus":
        return this.OtpStatus();
      case "changeEmail":
        return this.changeEmail();
      default:
        return (
          <EmailComponent
            handleEmailChange={this.handleEmailChange}
            handleSendOTP={this.handleSendOTP}
            email={this.state.email}
            emailError={this.state.emailError}
            styles={styles}
          />
        );
    }
  }
  render() {
    let styles = this.props.styles;

    if (this.state.currentStep === "changeEmail") {
      return (
        <div className={styles.change__email__wrapper}>{this.renderSteps()}</div>
      );
    } else {
      return (
        <div className={styles.component__wrapper}>{this.renderSteps()}</div>
      );
    }
  }
}

export default LoginComponent;
